import type { TimeState, WeatherKind, WeatherState } from '../../types/core';
import { pick } from '../../utils/random';

const weatherOptions: readonly WeatherKind[] = ['sunshine', 'clouds', 'rain', 'fog'];

export function updateWeather(weather: WeatherState, time: TimeState, rng: () => number): WeatherState {
  const absoluteMinute = time.day * 1440 + time.minuteOfDay;

  if (absoluteMinute < weather.nextChangeMinute) {
    return weather;
  }

  const kind = pick(weatherOptions, rng);
  const intensityByKind: Record<WeatherKind, number> = {
    sunshine: 0,
    clouds: 0.28 + rng() * 0.35,
    rain: 0.45 + rng() * 0.38,
    fog: 0.32 + rng() * 0.35
  };

  return {
    kind,
    intensity: intensityByKind[kind],
    cloudCover: kind === 'sunshine' ? 0.12 + rng() * 0.12 : 0.45 + rng() * 0.45,
    nextChangeMinute: absoluteMinute + 220 + Math.floor(rng() * 420)
  };
}

export function weatherLabel(kind: WeatherKind): string {
  const labels: Record<WeatherKind, string> = {
    sunshine: 'Sunshine',
    clouds: 'Clouds',
    rain: 'Rain',
    fog: 'Fog'
  };

  return labels[kind];
}
